import * as styles from "./TooltipViewport.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";

import type { TooltipViewportProps } from "./Tooltip.types";

export function TooltipViewport({
  className,
  ...props
}: TooltipViewportProps): JSX.Element {
  return (
    <BaseTooltip.Viewport
      data-slot="tooltip-viewport"
      className={clsx(styles.viewport, className)}
      {...props}
    />
  );
}
